import { Injectable } from '@angular/core';

import { ElLayoutDirectionService } from '../../../services/direction.service';


export enum ElGlobalLogicalPosition {
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
}

export enum ElGlobalPhysicalPosition {
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
}

export type ElGlobalPosition = ElGlobalPhysicalPosition | ElGlobalLogicalPosition;

@Injectable()
export class ElPositionHelper {
  constructor(protected layoutDirection: ElLayoutDirectionService) {
  }

  toLogicalPosition(position: ElGlobalPosition): ElGlobalLogicalPosition {
    if (Object.values(ElGlobalLogicalPosition).includes(position)) {
      return position as ElGlobalLogicalPosition;
    }

    if (this.layoutDirection.isLtr()) {
      return this.toLogicalPositionWhenLtr(position as ElGlobalPhysicalPosition);
    } else {
      return this.toLogicalPositionWhenRtl(position as ElGlobalPhysicalPosition);
    }
  }

  toPhysicalPosition(position: ElGlobalPosition): ElGlobalPhysicalPosition {
    if (Object.values(ElGlobalPhysicalPosition).includes(position)) {
      return position as ElGlobalPhysicalPosition;
    }

    if (this.layoutDirection.isLtr()) {
      return this.toPhysicalPositionWhenLtr(position as ElGlobalLogicalPosition);
    } else {
      return this.toPhysicalPositionWhenRtl(position as ElGlobalLogicalPosition);
    }
  }

  isTopPosition(position: ElGlobalPosition) {
    const logicalPosition = this.toLogicalPosition(position);

    return logicalPosition === ElGlobalLogicalPosition.TOP_END
      || logicalPosition === ElGlobalLogicalPosition.TOP_START;
  }

  isRightPosition(position: ElGlobalPosition) {
    const physicalPosition = this.toPhysicalPosition(position);

    return physicalPosition === ElGlobalPhysicalPosition.TOP_RIGHT
      || physicalPosition === ElGlobalPhysicalPosition.BOTTOM_RIGHT;
  }

  protected toLogicalPositionWhenLtr(position: ElGlobalPhysicalPosition): ElGlobalLogicalPosition {
    switch (position) {
      case ElGlobalPhysicalPosition.TOP_RIGHT:
        return ElGlobalLogicalPosition.TOP_END;
      case ElGlobalPhysicalPosition.TOP_LEFT:
        return ElGlobalLogicalPosition.TOP_START;
      case ElGlobalPhysicalPosition.BOTTOM_RIGHT:
        return ElGlobalLogicalPosition.BOTTOM_END;
      case ElGlobalPhysicalPosition.BOTTOM_LEFT:
        return ElGlobalLogicalPosition.BOTTOM_START;
    }
  }

  protected toLogicalPositionWhenRtl(position: ElGlobalPhysicalPosition): ElGlobalLogicalPosition {
    switch (position) {
      case ElGlobalPhysicalPosition.TOP_RIGHT:
        return ElGlobalLogicalPosition.TOP_START;
      case ElGlobalPhysicalPosition.TOP_LEFT:
        return ElGlobalLogicalPosition.TOP_END;
      case ElGlobalPhysicalPosition.BOTTOM_RIGHT:
        return ElGlobalLogicalPosition.BOTTOM_START;
      case ElGlobalPhysicalPosition.BOTTOM_LEFT:
        return ElGlobalLogicalPosition.BOTTOM_END;
    }
  }

  protected toPhysicalPositionWhenLtr(position: ElGlobalLogicalPosition): ElGlobalPhysicalPosition {
    switch (position) {
      case ElGlobalLogicalPosition.TOP_START:
        return ElGlobalPhysicalPosition.TOP_LEFT;
      case ElGlobalLogicalPosition.TOP_END:
        return ElGlobalPhysicalPosition.TOP_RIGHT;
      case ElGlobalLogicalPosition.BOTTOM_START:
        return ElGlobalPhysicalPosition.BOTTOM_LEFT;
      case ElGlobalLogicalPosition.BOTTOM_END:
        return ElGlobalPhysicalPosition.BOTTOM_RIGHT;
    }
  }

  protected toPhysicalPositionWhenRtl(position: ElGlobalLogicalPosition): ElGlobalPhysicalPosition {
    switch (position) {
      case ElGlobalLogicalPosition.TOP_START:
        return ElGlobalPhysicalPosition.TOP_RIGHT;
      case ElGlobalLogicalPosition.TOP_END:
        return ElGlobalPhysicalPosition.TOP_LEFT;
      case ElGlobalLogicalPosition.BOTTOM_START:
        return ElGlobalPhysicalPosition.BOTTOM_RIGHT;
      case ElGlobalLogicalPosition.BOTTOM_END:
        return ElGlobalPhysicalPosition.BOTTOM_LEFT;
    }
  }
}
